

export class WindowUtil {

    copyToClipboard = (text) => {

        var tempTextareaElement = document.createElement("textarea");
        document.body.appendChild(tempTextareaElement);
        tempTextareaElement.value = text;
        tempTextareaElement.select();
        document.execCommand("copy");
        document.body.removeChild(tempTextareaElement);

    }
};

const windowUtil = new WindowUtil();
export default windowUtil;